"use strict";

import React, {useState, useEffect} from 'react';
import {createPortal} from "react-dom";
import SwiperCore, {Thumbs, Navigation, Lazy, Pagination} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductGallerySlide from "./ProductGallerySlide";
import ProductGalleryThumbnailSlide from "./ProductGalleryThumbnailSlide";

SwiperCore.use([Thumbs, Navigation, Lazy, Pagination]);

const ProductGalleryFullScreen = ({
                                    slides=[],
                                    currentIndex=0,
                                    showFullScreen=false,
                                    lazyLoading={},
                                    onSlideChange=()=>{},
                                    onFullScreenClick=()=>{},
                                }) => {
    const [galleryThumbController, setGalleryThumbController] = useState(null);
    const loopedSlides = !!slides.length ? slides.length : 0;
    const magnifierProps = {className: 'magnify__images__container magnify__images__container--flex-vertical'};
    const spaceBetween = 10;

    useEffect(()=>{
        if(!showFullScreen){
            setGalleryThumbController(null);
        }
    }, [showFullScreen]);

    if(!!showFullScreen){
        return createPortal(
            <div className="slides__full-screen">
                <div className="slides__full-screen__inner">
                    <div className="slides__full-screen__content">
                        <div className="slides__full-screen__header">
                            <p className="slides__full-screen__toolbar__current-slide">
                                {currentIndex + 1} / {slides.length}
                            </p>
                            <a href="#" title="Full Screen"
                               onClick={onFullScreenClick}
                               className="slides__full-screen__toolbar__action-link btn__delete btn__delete--large" />
                        </div>
                        <div className="slides__full-screen__main-content" style={{}}>
                        {!!slides.length &&
                        <React.Fragment>
                            {slides.length === 1 &&
                                <React.Fragment>
                                    <ul className="swiper-wrapper">
                                        <li className="swiper-slide swiper-slide-active">
                                            <ProductGallerySlide slide={slides[0]}
                                                                 slideAltText={`Product Image`}
                                                                 magnifierProps={magnifierProps} />
                                        </li>
                                    </ul>
                                </React.Fragment>
                                ||
                                <Swiper
                                    thumbs={{ swiper: galleryThumbController, }}
                                    className={'product-detail__slides__container'}
                                    style={{height: '100%',}}
                                    tag="div"
                                    wrapperTag="ul"
                                    navigation
                                    slidesPerView={1}
                                    grabCursor={false}
                                    simulateTouch={false}
                                    loop={true}
                                    loopedSlides={loopedSlides}
                                    spaceBetween={spaceBetween}
                                    onSwiper={(swiper)=>{
                                        swiper.slideToLoop(currentIndex);
                                        swiper.on('slideChange', function () {
                                            onSlideChange(swiper);
                                        });
                                    }} >
                                    {slides.map((slide, index)=>
                                        <SwiperSlide key={`slideKey1-${index}`}
                                                     tag="li" >
                                            <ProductGallerySlide
                                                slide={slide}
                                                slideAltText={`Product Image`}
                                                magnifierProps={magnifierProps} />
                                        </SwiperSlide>
                                    )}
                                </Swiper>
                            }
                        </React.Fragment>
                        }
                        </div>
                        {slides.length && slides.length > 1 &&
                        <div className="slides__full-screen__footer">
                            <div className="product-detail__slides__thumbnail__container" >
                            <Swiper
                                className={''}
                                style={{marginBottom: '0',}}
                                tag="div"
                                wrapperTag="ul"
                                slidesPerView={'auto'}
                                watchSlidesProgress={true}
                                watchSlidesVisibility={true}
                                spaceBetween={spaceBetween}
                                lazy={{
                                    loadPrevNext: true,
                                    preloaderClass: lazyLoading.preLoaderClassName || '',
                                }}
                                onSwiper={(swiper) => {
                                    setGalleryThumbController(() => {
                                        return swiper;
                                    });
                                    //swiper.slideToLoop(currentIndex);
                                    swiper.once('slideChange', function () {
                                        swiper.lazy.load();
                                    });
                                }}>
                                {slides.map((slide, index) =>
                                    <SwiperSlide key={`slideThumb1-${index}`}
                                                 tag="li"
                                                 className="slides__full-screen__thumbnail"
                                                 style={{}}>
                                            <ProductGalleryThumbnailSlide thumbnail={slide}
                                                          imgAlt={'Product Slide Thumbnail'}
                                                          lazyLoad={index > 2}
                                                          lazyLoading={lazyLoading}/>
                                    </SwiperSlide>
                                )}
                            </Swiper>
                        </div>
                        </div>
                        }
                    </div> ,
                </div> ,
            </div> ,
            document.getElementById('product-detail__slides__full-screen__component')
        );
    }
    else
        return null;
};

export default ProductGalleryFullScreen;
